import {staticDir} from '@brand/settings';

export default {
	methods: {
		/**
         * Static Directory
         * @param  {String} location - Path of static resource
         * @return {String} location - Full path to asset with brand folder
         */
		staticDir(location) {
			return staticDir + location;
		},
		/**
         * Format Address
         * @param  {Object} address - Object from API containing key/values of address lines
         * @param  {String} type (optional- default 'string') - Type of address to return, either 'string' (concat'ed) or 'array'
         * @return formatted
         */
		formatAddress(address, type) {
			const order = ['line1', 'line2', 'line3', 'county', 'town', 'postcode', 'telephone'];
			const formatted = [];

			order.forEach((line) => {
				if (address[line] && address[line] !== '') formatted.push(address[line]);
			});

			if (address.country.name) {
				formatted.push(address.country.name);
			}

			return (type === 'array') ? formatted : formatted.join(', ');
		},

		postMessage(data, target) {
			window.parent.postMessage(data, '*');
		},

		/* Data compiled from Vuex to submit errors to Sentry.io */
		sentryData(serverResponse) {

			let payload = {
				tags: {
					basketLength: this.$store.state.basket.lines.length,
					venueName: this.$store.state.venue.name
				},
				extra: {
					breakpoint: this.$store.state.breakpoint,
					menuId: this.$store.state.menuId,
					iframe: this.$store.state.iframe
				},
				user: {
					location: this.$store.state.user.location
				}
			};

			/* Check if user is logged in */
			if (this.$store.state.user.account.user) {
				payload.user = {
					email: this.$store.state.user.account.user.email,
					name: this.$store.state.user.account.user.firstName + ' ' + this.$store.state.user.account.user.lastName,
					id: this.$store.state.user.account.user.id
				};
			}

			/* Selected timeslot */
			if (this.$store.state.timeslot) {
				payload.extra.timeslot = this.$store.state.timeslot.time;
			}

			/* Add additional zonal error info */
			if (serverResponse) {
				payload.extra.zonal = serverResponse;
			}

			/* Stringify basket items */
			if (this.$store.state.basket.lines.length > 0) {
				const lineItems = this.$store.state.basket.lines.map(item => `${item.displayName} (x${item.quantity})`).join(', ');
				payload.extra.basketLines = lineItems;
			}

			return payload;
		}
	}
};



// WEBPACK FOOTER //
// ./src/vue/mixins/mixins.js